import { z } from "zod";
import { passwordValidation } from "../../constants/regex";
import { zEmailSchema, zString } from "./commonSchemaObjects";

export const userCreationSchema = z
  .object({
    first_name: zString.zRequired,
    last_name: zString.zRequired,
    email: zEmailSchema,
    roles: z.array(z.string()).min(1, "Minimum one role(s) is required"),
    default_role: z
      .string({ invalid_type_error: "Required" })
      .min(1, "Required"),
    password: zString.zRequired
      .min(8, "Password should have minimum 8 characters")
      .regex(passwordValidation, "Password is not in expected format"),
    confirmPassword: zString.zRequired,
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ["confirmPassword"],
  });

export const userUpdateSchema = z.object({
  first_name: zString.zRequired,
  last_name: zString.zRequired,
  email:zEmailSchema,
  roles: z.array(z.string()).min(1, "Minimum one role(s) is required"),
  default_role: z.string({ invalid_type_error: "Required" }).min(1, "Required"),
});
